<nz-card nzTitle="Users" [nzExtra]="extraTemplate" class="shadow-sm">

	<nz-table #basicTable [nzData]="users" [nzLoading]="loading" [nzPageSize]="10" [nzBordered]="true" nzSize="middle">

		<thead>
			<tr>
				<th>ID</th>
				<th>Created</th>
				<th>Username</th>
				<th>Name</th>
				<th>Surname</th>
				<th>Email</th>
				<th nzAlign="center">Status</th>
				<th nzAlign="center">Action</th>
			</tr>
		</thead>

		<tbody>
			@for (user of basicTable.data; track user.id) {
			<tr>
				<td>{{ user.id }}</td>
				<td>{{ user.createdAt | date: 'yyyy-MM-dd' }}</td>
				<td>{{ user.username }}</td>
				<td>{{ user.name }}</td>
				<td>{{ user.surname }}</td>
				<td>{{ user.email }}</td>

				<td nzAlign="center">
					@switch (user.status) {
					@case (UserStatusEnum.Active) {
					<span nz-icon nzType="check-circle" nzTheme="twotone" nzTwotoneColor="#52c41a" nz-tooltip
						nzTooltipTitle="Active"></span>
					}
					@case (UserStatusEnum.Disabled) {
					<span nz-icon nzType="minus-circle" nzTheme="twotone" nzTwotoneColor="#ff4d4f" nz-tooltip
						nzTooltipTitle="Disabled"></span>
					}
					@case (UserStatusEnum.Blocked) {
					<span nz-icon nzType="lock" nzTheme="twotone" nzTwotoneColor="#faad14" nz-tooltip
						nzTooltipTitle="Blocked"></span>
					}
					@case (UserStatusEnum.New) {
					<span nz-icon nzType="flag" nzTheme="twotone" nzTwotoneColor="#1890ff" nz-tooltip
						nzTooltipTitle="New"></span>
					}
					@default {
					<span nz-icon nzType="question-circle" nzTheme="outline" nz-tooltip nzTooltipTitle="Unknown"></span>
					}
					}
				</td>

				<td nzAlign="center">
					<button nz-button nzType="default" nzSize="small" (click)="editUser(user)"
						class="btn-icon-flex btn-spacer">
						<span nz-icon [nzType]="authService.hasAccess(PermissionEnum.UsersEdit) ? 'edit' : 'eye'" style="margin-right: 4px;"></span>
						{{ authService.hasAccess(PermissionEnum.UsersEdit) ? 'Edit' : 'View Details' }}
					</button>

					@if (authService.hasAccess(PermissionEnum.UsersEdit)) {
						<button nz-button nzType="default" nzSize="small" nz-dropdown [nzDropdownMenu]="menu"
							class="btn-icon-flex">
							More <span nz-icon nzType="down" style="margin-left: 4px;"></span>
						</button>

						<nz-dropdown-menu #menu="nzDropdownMenu">
							<ul nz-menu>

								<li nz-menu-item (click)="resetPassword(user)">
									<span nz-icon nzType="key"></span> Reset Password
								</li>
								<li nz-menu-item (click)="editPermissions(user)">
									<span nz-icon nzType="safety-certificate"></span> Permissions
								</li>

								@if (user.status === UserStatusEnum.Active || user.status === UserStatusEnum.Disabled ||
									user.status === UserStatusEnum.Blocked) {

									<li nz-menu-divider></li>

									@if (user.status === UserStatusEnum.Active) {
									<li nz-menu-item nzDanger (click)="disable(user)">
										<span nz-icon nzType="stop"></span> Disable
									</li>
									}
									@else if (user.status === UserStatusEnum.Disabled) {
									<li nz-menu-item (click)="enable(user)">
										<span nz-icon nzType="check-circle" nzTheme="twotone" nzTwotoneColor="#52c41a"></span>
										Enable
									</li>
									}
									@else if (user.status === UserStatusEnum.Blocked) {
									<li nz-menu-item (click)="unblock(user)">
										<span nz-icon nzType="unlock" nzTheme="twotone" nzTwotoneColor="#faad14"></span> Unblock
									</li>
									}
								}
							</ul>
						</nz-dropdown-menu>
					}
				</td>
			</tr>
			}
		</tbody>
	</nz-table>

</nz-card>

<ng-template #extraTemplate>
	@if (authService.hasAccess(PermissionEnum.UsersAdd)) {
		<button nz-button nzType="primary" (click)="addUser()">
			<span nz-icon nzType="plus"></span> Add User
		</button>
	}
</ng-template>

<app-add-user-modal modalId="addUserModal" (saved)="onSave()"></app-add-user-modal>
<app-edit-user-modal modalId="editUserModal" (saved)="onSave()"></app-edit-user-modal>
<app-reset-password-modal modalId="resetPasswordModal"></app-reset-password-modal>
<app-permissions-modal modalId="permissionModal"></app-permissions-modal>